import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import MUIPopper from '@mui/material/Popper';
export const PopperClassName = 'MFPopper-root';
/**
 * Override of MUI's Popper with a custom class name to enable external styling
 */
export const Popper = ({ ref, ...props }) => {
    // z-index 1301 ensures poppers render above MUI's Drawer (1200) and Modal (1300)
    return _jsx(MUIPopper, { className: PopperClassName, sx: { zIndex: 1301 }, ...props, ref: ref });
};
